// import { useAuth } from "contexts/AuthContext";
// import { useTranslation } from "contexts/i18nContext";
// import { useNotifications } from "contexts/NotificationContext";
// import { formatDistanceToNow } from "date-fns";
// import { Bell, CheckCircle, Circle, LogOut, RefreshCw, X } from "lucide-react";
// import React, { useState } from "react";

// interface HeaderProps {
//   handleLogout: () => void;
// }

// const Header: React.FC<HeaderProps> = ({ handleLogout }) => {
//   const { user } = useAuth();
//   // const updateAuth = useAuthUpdate();
//   // const navigate = useNavigate();

//   const {
//     notifications,
//     // unreadCount,
//     markAsRead,
//     refreshNotifications,
//   } = useNotifications();

//   const { language, changeLanguage } = useTranslation();

//   const [showNotificationPanel, setShowNotificationPanel] = useState(false);

//   const handleBellClick = () => {
//     setShowNotificationPanel((prev) => !prev);
//   };

//   const handleCloseNotificationPanel = () => {
//     setShowNotificationPanel(false);
//   };

//   const handleNotificationClick = (notificationId: string, isRead: boolean) => {
//     if (!isRead) {
//       markAsRead(notificationId);
//     }
//   };

//   // Get the actual unread notifications from the current list
//   const actualUnreadNotifications = notifications.filter((n) => !n.is_read);
//   const actualUnreadCount = actualUnreadNotifications.length;

//   return (
//     <header className="flex items-center justify-between px-6 py-4 bg-white border-b border-gray-200 shadow-sm">
//       {/* Title section */}
//       <div className="flex items-center gap-3">
//         <div className="h-10 border-l-4 border-blue-600" />
//         <div className="leading-tight">
//           <div className="text-lg font-semibold text-gray-800">Discipline</div>
//           <div className="text-sm font-medium text-blue-600">
//             B.A.A.W.O. System
//           </div>
//         </div>
//       </div>

//       {/* Right section */}
//       <div className="flex items-center gap-4">
//         {/* Language switcher */}
//         <select
//           value={language}
//           onChange={(e) => changeLanguage(e.target.value as "en" | "am")}
//           className="px-3 py-1.5 text-sm rounded-lg border border-gray-300 bg-white text-gray-800 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
//         >
//           <option value="en">🌐 English</option>
//           <option value="am">🌐 አማርኛ</option>
//         </select>

//         {/* Notification bell */}
//         <div className="relative">
//           <button
//             onClick={handleBellClick}
//             className={`relative p-2 rounded-lg transition-colors ${
//               showNotificationPanel
//                 ? "bg-blue-50 border border-blue-200"
//                 : "bg-white border border-gray-200 hover:bg-blue-50"
//             }`}
//           >
//             <Bell
//               className={`w-5 h-5 ${
//                 showNotificationPanel ? "text-blue-600" : "text-gray-600"
//               }`}
//             />
//             {actualUnreadCount > 0 && (
//               <span className="absolute -top-1 -right-1 bg-red-600 text-white text-xs font-bold min-w-5 h-5 flex items-center justify-center rounded-full border border-white">
//                 {actualUnreadCount > 9 ? "9+" : actualUnreadCount}
//               </span>
//             )}
//           </button>

//           {/* Notification Dropdown */}
//           {showNotificationPanel && (
//             <div className="absolute -right-4 top-full mt-2 w-96 bg-white rounded-lg shadow-xl border border-gray-200 z-50">
//               {/* Header */}
//               <div className="px-4 py-3 border-b border-gray-200 bg-gray-50 rounded-t-lg">
//                 <div className="flex justify-between items-center">
//                   <h3 className="text-lg font-semibold text-gray-800 flex items-center gap-2">
//                     <Bell className="w-5 h-5 text-blue-600" />
//                     Notifications
//                     {actualUnreadCount > 0 && (
//                       <span className="bg-red-600 text-white text-xs font-medium px-2 py-1 rounded-full">
//                         {actualUnreadCount} new
//                       </span>
//                     )}
//                   </h3>
//                   <div className="flex items-center gap-2">
//                     <button
//                       onClick={refreshNotifications}
//                       className="text-gray-400 hover:text-blue-600 transition-colors"
//                       title="Refresh notifications"
//                     >
//                       <RefreshCw className="w-4 h-4" />
//                     </button>
//                     <button
//                       onClick={handleCloseNotificationPanel}
//                       className="text-gray-400 hover:text-gray-600 transition-colors"
//                     >
//                       <X className="w-5 h-5" />
//                     </button>
//                   </div>
//                 </div>
//               </div>

//               {/* Notifications List */}
//               <div className="max-h-96 overflow-y-auto">
//                 {notifications.length === 0 ? (
//                   <div className="px-4 py-8 text-center text-gray-500">
//                     <Bell className="w-12 h-12 mx-auto text-gray-300 mb-2" />
//                     <p className="text-gray-600">No notifications</p>
//                     <p className="text-sm text-gray-500 mt-1">
//                       New assignments will appear here
//                     </p>
//                   </div>
//                 ) : (
//                   notifications.slice(0, 10).map((notification) => (
//                     <div
//                       key={notification.id}
//                       onClick={() =>
//                         handleNotificationClick(
//                           notification.id,
//                           notification.is_read
//                         )
//                       }
//                       className={`
//                         px-4 py-3 border-b border-gray-100 last:border-b-0
//                         transition-all duration-200 cursor-pointer
//                         ${
//                           notification.is_read
//                             ? "bg-white hover:bg-gray-50"
//                             : "bg-blue-50 hover:bg-blue-100 border-l-4 border-l-blue-500"
//                         }
//                       `}
//                     >
//                       <div className="flex items-start gap-3">
//                         {/* Status Indicator */}
//                         <div className="flex-shrink-0 mt-0.5">
//                           {notification.is_read ? (
//                             <CheckCircle className="w-4 h-4 text-green-500" />
//                           ) : (
//                             <Circle className="w-4 h-4 text-red-500 fill-red-500" />
//                           )}
//                         </div>

//                         {/* Content */}
//                         <div className="flex-1 min-w-0">
//                           <div
//                             className={`
//                             text-sm leading-relaxed mb-1
//                             ${
//                               notification.is_read
//                                 ? "text-gray-700"
//                                 : "text-gray-900 font-medium"
//                             }
//                           `}
//                           >
//                             {notification.message}
//                           </div>

//                           <div className="flex justify-between items-center text-xs">
//                             <span
//                               className={`${
//                                 notification.is_read
//                                   ? "text-gray-500"
//                                   : "text-blue-600"
//                               }`}
//                             >
//                               {formatDistanceToNow(
//                                 new Date(notification.timestamp),
//                                 { addSuffix: true }
//                               )}{" "}
//                               (
//                               {new Date(
//                                 notification.timestamp
//                               ).toLocaleString()}
//                               )
//                             </span>
//                             {!notification.is_read && (
//                               <span className="text-red-600 text-xs font-medium bg-red-100 px-2 py-1 rounded-full">
//                                 New
//                               </span>
//                             )}
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   ))
//                 )}
//               </div>

//               {/* Footer */}
//               {notifications.length > 10 && (
//                 <div className="px-4 py-2 border-t border-gray-200 text-center text-sm text-gray-500 bg-gray-50 rounded-b-lg">
//                   Showing 10 of {notifications.length} notifications
//                 </div>
//               )}
//             </div>
//           )}
//         </div>

//         {/* User info */}
//         <div className="flex items-center gap-2 mr-8">
//           <div className="text-right">
//             <div className="text-sm font-medium text-gray-800">
//               {user?.full_name || "-"}
//             </div>
//             <div className="text-xs text-gray-500">{user?.email || "-"}</div>
//           </div>
//           <img
//             src={require("../images/avatar.png")}
//             alt="User Avatar"
//             width={32}
//             height={32}
//             className="object-cover rounded-full border border-gray-300"
//           />
//         </div>

//         {/* Logout button */}
//         <button
//           onClick={handleLogout}
//           title="Logout"
//           className="p-2 rounded-lg bg-white border border-gray-200 hover:bg-gray-50 hover:border-gray-300 transition-colors"
//         >
//           <LogOut className="text-gray-600 w-5 h-5" />
//         </button>
//       </div>
//     </header>
//   );
// };

// export default Header;

// import { useAuth, useAuthUpdate } from "contexts/AuthContext";
// import { useNotifications } from "contexts/NotificationContext";
import { Bell } from "lucide-react";
import React, { useState } from "react";
import personImg from "../images/person.png";
// import PopupNotification from "./PopupNotification";
import { useAuth, useAuthUpdate } from "context/AuthContext";
import { useNotifications } from "context/NotificationContext";
import { LoginAccount } from "types";
import i18n from "../i18n";
import PopupNotification from "./PopupNotification";

interface User {
  name: string;
  role: string;
  avatar?: string;
  email: string;
}
interface NavItems {
  name: String;
  href: string;
}
type HeaderProps = {
  isInternalUser: boolean;
};
export interface JwtPayload {
  exp?: number; // Expiration time in seconds
  iat?: number; // Issued at
  sub?: string; // Subject (user id, etc.)
  [key: string]: any; // Any additional claims
}

const Header: React.FC<HeaderProps> = ({ isInternalUser }) => {
  // ✅ In a real app, this would come from context or Redux
  const { loginData } = useAuth();

  const isMember = sessionStorage.getItem("authToken") === "Member";
  // console.log(sessionStorage.getItem("authToken"));

  const [tokenLoaded, setTokenLoaded] = useState(false);
  const updateAuthContext = useAuthUpdate();

  const handleLogout = () => {
    sessionStorage.removeItem("authToken");
    updateAuthContext({
      loginData,
      token: "",
      isAuthenticated: false,
      setLoginData: function (token: LoginAccount | null): void {
        throw new Error("Function not implemented.");
      },
      logout: function (): void {
        throw new Error("Function not implemented.");
      },
    });
    window.location.href = "/login";
  };

  const [logoutBtn, setLogoutBtn] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const { unreadCount } = useNotifications();

  const currentUser: User = {
    name:
      loginData?.full_name ||
      (loginData?.full_name ? `${loginData.full_name} ` : "") ||
      "",
    role:
      loginData?.roles && loginData?.roles?.length > 1
        ? loginData?.roles[1]
        : loginData?.roles?.length
          ? loginData.roles[0]
          : "User", // Default to 'User' if no roles are defined
    email: loginData?.email || loginData?.email || "",
    avatar: personImg, // default for now, can be updated after login
  };

  // const navigationItems: NavItems[] = [
  //   { name: "Home", href: "#home" },
  //   { name: "About", href: "#about" },
  //   { name: "Jobs", href: "#jobs" },
  //   { name: "Request", href: "#request" },
  //   { name: "FAQ", href: "#faq" },
  // ];

  if (!isMember)
    return renderInsideUserHeader(
      currentUser,
      handleLogout,
      logoutBtn,
      setLogoutBtn,
      unreadCount,
      showNotification,
      setShowNotification,
    );
  return <></>;
};

const renderInsideUserHeader = (
  user: User,
  handleLogout: any,
  logoutBtn: boolean,
  setLogoutBtn: any,
  unreadCount: any,
  showNotification: boolean,
  setShowNotification: React.Dispatch<React.SetStateAction<boolean>>,
) => (
  <header className="flex items-center justify-between px-6 py-4 bg-white border-b border-gray-200 shadow-sm">
    {/* Title section */}
    <div className="flex items-center gap-3">
      <div className="h-10 border-l-4 border-red-600" />
      <div className="leading-tight">
        <div className="text-lg font-semibold text-gray-800">
          Crime Case Management
        </div>
        <div className="text-sm font-medium text-red-600">
          B.A.A.W.O. System
        </div>
      </div>
    </div>

    {/* Right user info */}
    {/* user icon  */}
    <div className="flex gap-4 ml-auto mr-8">
      <select
        value={i18n.language}
        onChange={(e) => {
          const lang = e.target.value;
          i18n.changeLanguage(lang);
          localStorage.setItem("language", lang);
        }}
        className="px-3 py-1.5 text-sm rounded-md border border-gray-300 bg-gray-100 text-gray-800 shadow-sm focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-red-500 transition"
      >
        <option value="or">🌐 Afaan Oromoo</option>
        <option value="en">🌐 English</option>
        <option value="am">🌐 አማርኛ</option>
      </select>
      <button
        data-notification-bell
        onClick={() => setShowNotification(!showNotification)}
        className={`relative p-2 rounded-lg hover:bg-gray-200 ${
          showNotification ? "bg-gray-300" : "bg-gray-100"
        }`}
      >
        <Bell className="text-gray-700" />
        {unreadCount >= 0 && (
          <span className="absolute -top-1 -right-1 bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full">
            {unreadCount}
          </span>
        )}
      </button>
    </div>
    <div className="flex items-center gap-2 relative">
      <div
        className="hidden sm:block text-right"
        onClick={() => setLogoutBtn(!logoutBtn)}
      >
        <div className="text-base font-semibold text-[#0A1D39]">
          {user.name}
        </div>
        <div className="text-sm font-normal text-[#432101]">{user.role}</div>
      </div>

      <div className="flex gap-3 relative">
        <img
          src={user.avatar}
          alt="User Avatar"
          width={32}
          height={32}
          className="object-cover rounded-full"
        />
        <div className="my-auto">
          <svg
            width="10"
            height="8"
            viewBox="0 0 10 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M5 8L0.669872 0.499999L9.33013 0.5L5 8Z" fill="#D9D9D9" />
          </svg>
        </div>
      </div>
      {/*logoutBtn &&
                <div className="bg-white absolute right-0 top-12 rounded shadow-lg" >
                    <div
                        className="flex flex-row gap-3 items-center cursor-pointer px-3 py-2 rounded font-medium hover:bg-gray-100"
                        onClick={handleLogout}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="h-4 w-4"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            strokeWidth={2}
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1m0-10V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2h6a2 2 0 002-2v-1"
                            />
                        </svg>
                        <div>Logout</div>
                    </div>
                </div>
            */}
      {showNotification && (
        <PopupNotification onClose={() => setShowNotification(false)} />
      )}
    </div>
    {/* user icon  */}
  </header>
);

// const renderStakeholderHeader = (
//   navItems: NavItems[],
//   user: User,
//   handleLogout: any,
//   logoutBtn: boolean,
//   setLogoutBtn: React.Dispatch<React.SetStateAction<boolean>>
// ) => (
//   <header className="fixed z-20 top-0 left-0 right-0 bg-black border-b">
//     {/* Background Pattern */}
//     <div className="absolute inset-0 opacity-10">
//       <div
//         className="absolute inset-0"
//         style={{
//           backgroundImage: `
//             linear-gradient(45deg, transparent 35%, rgba(255, 255, 255, 0.1) 35%, rgba(255, 255, 255, 0.1) 65%, transparent 65%),
//             linear-gradient(-45deg, transparent 35%, rgba(255, 255, 255, 0.1) 35%, rgba(255, 255, 255, 0.1) 65%, transparent 65%)
//           `,
//           backgroundSize: "20px 20px",
//           backgroundPosition: "0 0, 10px 10px",
//         }}
//       />
//     </div>

//     {/* Additional diagonal lines for more complexity */}
//     <div className="absolute inset-0 opacity-5">
//       <div
//         className="absolute inset-0"
//         style={{
//           backgroundImage: `
//             linear-gradient(30deg, transparent 40%, rgba(255, 255, 255, 0.15) 40%, rgba(255, 255, 255, 0.15) 60%, transparent 60%),
//             linear-gradient(-30deg, transparent 40%, rgba(255, 255, 255, 0.15) 40%, rgba(255, 255, 255, 0.15) 60%, transparent 60%)
//           `,
//           backgroundSize: "40px 40px",
//           backgroundPosition: "0 0, 20px 20px",
//         }}
//       />
//     </div>

//     <div className="px-4 sm:px-6 lg:px-5 relative z-10 my-auto">
//       <div className="flex items-center justify-between h-16">
//         {/* Logo Section */}
//         <div className="flex items-center gap-2">
//           <img
//             src={logo}
//             alt="Logo"
//             className="w-8 h-8 md:w-10 md:h-10 rounded"
//           />
//           <div className="text-xs leading-tight">
//             <div className="text-sm text-white font-semibold">
//               Biiroo Abbaa Alangaa W.O.
//             </div>
//             <div className="text-gray-400 text-[11px] hidden sm:block">
//               ቢሮዎ አባ አላንጋ ወ.ኦ.
//             </div>
//           </div>
//         </div>

//         <div className="flex items-center gap-4 relative group">
//           {/* Desktop Navigation */}
//           <nav className="hidden space-x-8">
//             {navItems.map((item, index) => (
//               <a
//                 key={index}
//                 href={item.href}
//                 className="text-gray-300 hover:text-white transition-colors duration-200 font-medium text-sm tracking-wide"
//               >
//                 {item.name}
//               </a>
//             ))}
//           </nav>

//           {/* user icon  */}
//           <div
//             className="flex items-center gap-2 relative"
//             onClick={() => setLogoutBtn(!logoutBtn)}
//           >
//             <div className="hidden sm:block text-right">
//               <div className="text-base font-semibold text-white">
//                 {user.name}
//               </div>
//               <div className="text-sm font-normal text-red-600">
//                 {user.email}
//               </div>
//             </div>

//             <div className="flex gap-3 relative">
//               <img
//                 src={user.avatar}
//                 alt="User Avatar"
//                 width={32}
//                 height={32}
//                 className="object-cover rounded-full"
//               />
//               <div className="my-auto">
//                 <svg
//                   width="10"
//                   height="8"
//                   viewBox="0 0 10 8"
//                   fill="none"
//                   xmlns="http://www.w3.org/2000/svg"
//                 >
//                   <path
//                     d="M5 8L0.669872 0.499999L9.33013 0.5L5 8Z"
//                     fill="#D9D9D9"
//                   />
//                 </svg>
//               </div>
//             </div>
//             {logoutBtn && (
//               <div className="bg-white absolute right-0 top-12 rounded shadow-lg">
//                 <div
//                   className="flex flex-row gap-3 items-center cursor-pointer px-3 py-2 rounded font-medium hover:bg-gray-100"
//                   onClick={handleLogout}
//                 >
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     className="h-4 w-4"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                     strokeWidth={2}
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1m0-10V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2h6a2 2 0 002-2v-1"
//                     />
//                   </svg>
//                   <div>Logout</div>
//                 </div>
//               </div>
//             )}
//           </div>
//           {/* user icon  */}
//         </div>
//       </div>
//     </div>
//   </header>
// );
export default Header;
